export const mod = (a, b) => {
    let r = a % b;
    if (r < 0) {
        if (b > 0) {
            r = r + b;
        }
        else {
            r = r - b;
        }
    }
    return r;
};
